import axios from "axios";

export const state = {
  booking_info: {},
  is_payment_step: false
};

export const mutations = {
  setBookingInfo(state, data) {
    state.booking_info = { ...data };
  },
  setIsPaymentStep(state, value) {
    state.is_payment_step = value;
  },
};

export const actions = {
  booking({ dispatch, commit }, submitData) {
    return axios
        .post(appUrl + "/api/booking/reserve",  submitData,{
          headers: { Authorization: "Bearer auth sau" },
        })
        .then((res) => {
          return res;
        })
        .catch((error) => {
          throw error;
        });
  },
  cancelTicket({ dispatch, commit }, submitData) {
    return axios
        .post(appUrl + "/api/booking/refund",  submitData,{
          headers: { Authorization: "Bearer auth sau" },
        })
        .then((res) => {
          return res;
        })
        .catch((error) => {
          throw error;
        });
  },
  bookingInfo({ dispatch, commit }, params) {
    return axios
        .get(appUrl + "/api/booking", {
          params,
          headers: { Authorization: "Bearer auth sau" },
        })
        .then((res) => {
          return res;
        })
        .catch((error) => {
          throw error;
        });
  },
  cancelInfo({ dispatch, commit }, params) {
    return axios
        .get(appUrl + "/api/booking/refund-info", {
          params,
          headers: { Authorization: "Bearer auth sau" },
        })
        .then((res) => {
          return res;
        })
        .catch((error) => {
          throw error;
        });
  },
};
